import { ApolloClient } from '@apollo/client';

import type {
  GetDraftLessonActivitiesQuery,
  GetDraftLessonActivitiesQueryVariables,
} from '../../lesson-builder.graphql.generated';
import type { InteractiveLessonSectionOverviewFragment } from '../../lesson-builder.graphql.generated';
import type {
  GetDraftAssessmentActivitiesQuery,
  GetDraftAssessmentActivitiesQueryVariables,
} from '../../assessment/assessment-builder.graphql.generated';
import { GET_DRAFT_ASSESSMENT_ACTIVITIES } from 'approot/activity-builder/assessment/assessment-builder.graphql';
import { ActivityProperties } from 'approot/activity-builder/components/activity/activity.constants';
import { GET_DRAFT_LESSON_ACTIVITIES } from 'approot/activity-builder/lesson-builder.graphql';
import {
  ActivitiesContentType,
  ASSESSMENT_ACTIVITIES,
  LESSON_ACTIVITIES,
} from 'global/constants';

export const updateSectionsOverviewInCache = (
  client: ApolloClient<any>,
  contentId: number,
  contentType: ActivitiesContentType,
  classId: number,
  sectionId: string,
  updatedProperties: ActivityProperties
) => {
  const cache = client.cache;

  if (contentType === LESSON_ACTIVITIES) {
    const data = cache.readQuery<
      GetDraftLessonActivitiesQuery,
      GetDraftLessonActivitiesQueryVariables
    >({
      query: GET_DRAFT_LESSON_ACTIVITIES,
      variables: {
        input: {
          contentId,
          classId,
        },
      },
    });

    if (data?.getDraftLessonActivities?.sectionsOverview) {
      const updatedSectionsOverview =
        data.getDraftLessonActivities.sectionsOverview.map(
          (section: InteractiveLessonSectionOverviewFragment) => {
            if (section.id === sectionId) {
              return {
                ...section,
                differentiation:
                  updatedProperties.activitySettings?.differentiation,
              };
            }
            return section;
          }
        );

      cache.writeQuery<
        GetDraftLessonActivitiesQuery,
        GetDraftLessonActivitiesQueryVariables
      >({
        query: GET_DRAFT_LESSON_ACTIVITIES,
        variables: {
          input: {
            contentId,
            classId,
          },
        },
        data: {
          ...data,
          getDraftLessonActivities: {
            ...data.getDraftLessonActivities,
            sectionsOverview: updatedSectionsOverview,
          },
        },
      });
    }
  } else if (contentType === ASSESSMENT_ACTIVITIES) {
    const data = cache.readQuery<
      GetDraftAssessmentActivitiesQuery,
      GetDraftAssessmentActivitiesQueryVariables
    >({
      query: GET_DRAFT_ASSESSMENT_ACTIVITIES,
      variables: {
        input: {
          contentId,
          classId,
        },
      },
    });

    if (data?.getDraftAssessmentActivities?.sectionsOverview) {
      const updatedSectionsOverview =
        data.getDraftAssessmentActivities.sectionsOverview.map(
          (section: InteractiveLessonSectionOverviewFragment) => {
            if (section.id === sectionId) {
              return {
                ...section,
                differentiation:
                  updatedProperties.activitySettings?.differentiation,
              };
            }
            return section;
          }
        );

      cache.writeQuery<
        GetDraftAssessmentActivitiesQuery,
        GetDraftAssessmentActivitiesQueryVariables
      >({
        query: GET_DRAFT_ASSESSMENT_ACTIVITIES,
        variables: {
          input: {
            contentId,
            classId,
          },
        },
        data: {
          ...data,
          getDraftAssessmentActivities: {
            ...data?.getDraftAssessmentActivities,
            sectionsOverview: updatedSectionsOverview,
          },
        },
      });
    }
  }
};
